(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Dispositivo_os', Dispositivo_os);

    Dispositivo_os.$inject = ['$resource'];

    function Dispositivo_os ($resource) {
        var resourceUrl =  'api/dispositivo-os/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
